import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-stop",
  templateUrl: "./stop.component.html",
  styleUrls: ["./stop.component.scss"],
})
export class StopComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
